const enhancedChat = {
  orgId: '00DcT00000126Wz',
  deploymentName: 'Urban_Air_Enhanced_Chat',
  siteUrl: 'https://unleashedbrands--fullub.sandbox.my.site.com/ESWUrbanAirChat1770115339057',
  scrt2URL: 'https://unleashedbrands--fullub.sandbox.my.salesforce-scrt.com'
};

const enhancedBookingChat = {
  orgId: '00D5f000006N2n3',
  deploymentName: 'Urban_Air_Enhanced_Booking_Chat',
  siteUrl: 'https://unleashedbrands.my.site.com/ESWUrbanAirEnhancedBoo1770344373214',
  scrt2URL: 'https://unleashedbrands.my.salesforce-scrt.com'
};

// each env can point to its own config setting
export const chatConfigLocal = enhancedChat;
export const chatConfigDev = enhancedChat;
export const chatConfigTest = enhancedBookingChat;
export const chatConfigStage = enhancedBookingChat;
export const chatConfigProd = enhancedBookingChat;  // will be used in cloudha too
